import React, { useEffect, useState } from "react";
import portalService from "../services/portalService";
import localStorageService from "../services/localStorageService";

const Schedules = () => {
    const [schedules, setSchedules] = useState([]);

    const [displayName, setDislayName] = useState("");
    const [monthCount, setMonthCount] = useState(0);

    const fetchSchedules = async() => {
        portalService.getSchedules()
            .then(s => {
                localStorageService.schedules.set(s.data);
                setSchedules(s.data);
            })
            .catch(e => {

            });
    }

    useEffect(() => {
        if (localStorageService.schedules.get()) {
            setSchedules(localStorageService.schedules.get());
        } else {
            fetchSchedules();
        }
    }, []);

    const clearFields = () => {
        setMonthCount(0);
        setDislayName("");
    }

    const modalClosed = (e) => {
        clearFields();
    }

    const addNew = (e) => {
        portalService.addSchedule({
            displayName,
            monthCount
        }).then(r => {
            const newItem = r.data;
            const existing = localStorageService.schedules.get();
            existing.push(newItem);
            localStorageService.schedules.set(existing);
            setSchedules(existing);
            clearFields();
        }).catch(e => {
            console.log(e);
        }).finally(() => {
            
        })
    }

    const modal = () => {
        return (
            <div className="modal fade" id="new-box-schedule" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 v="modal-title fs-5" id="staticBackdropLabel">Новый период аренды</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form className="form-floating">
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-box-code" required placeholder="" value={displayName} onChange={(e) => setDislayName(e.target.value)}/>
                                    <label htmlFor="new-box-code">Название</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="new-box-num" required placeholder="" value={monthCount} onChange={(e) => setMonthCount(e.target.value)}/>
                                    <label htmlFor="new-box-num">Количество месяцев</label>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClosed}>Закрыть</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={addNew}>Сохранить</button>
                                </div>
                            </form>
                        </div>       
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="">
            <h3 className="mb-4">Сроки аренды</h3>
            <table className="table table-striped table-hover">
                <thead className="table">
                    <tr>
                        <th scope="col">Название</th>
                        <th scope="col">Количество месяцев</th>
                    </tr>
                </thead>
                <tbody>
                    {schedules.map((row) => (
                        <tr key={row.id}>
                            <td>{row.displayName}</td>
                            <td>{row.monthCount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div>
                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#new-box-schedule">Добавить+</button>
            </div>
            {modal()}
        </div>
    );
}

export default Schedules;